import * as React from 'react'

import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'

import { Checkbox } from 'components'

import './style.scss'

interface IProps {
  label: string
  input: any
  onChangeRadio: any
  initialValue?: string
}

interface IState {
  value: string
}

enum Gender {
  male = 'male',
  female = 'female'
}

export class RadioInputComponent extends React.Component<IProps, IState> {
  state = {
    value: ''
  }

  handleChange = (value: string) => {
    this.setState({ value })
    this.props.onChangeRadio(value)
  }

  componentDidMount() {
    const { initialValue } = this.props
    this.setState({ value: initialValue ? initialValue : '' })
  }

  render() {
    const { input, label } = this.props
    const { value } = input

    return (
      <FormControl className="radio-form-control">
        <FormLabel className="radio-form-label">{label}</FormLabel>
        <div className="checkboxes">
          {Object.values(Gender).map((val, i) => (
            <Checkbox
              key={i}
              value={value === val}
              onClick={() => this.handleChange(val)}
              className={`radio-form-control-label ${val}`}
              label={val}
            />
          ))}
        </div>
      </FormControl>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RadioInput/index.tsx